module.exports = "/images/smarty-says-mrs.png?c5332375e7058ca7ca99332b5897a1b4";